interface AddressResponse {
  STATUS: string
  prequal: {
    City: string
    ZipCode: string
    Street: string
    HouseNumber: string
    Bus: string
    VDSLStatus: string
    FiberStatus: string
    MaxVDSLSpeed: string
    MaxVDSLDownloadSpeed: string
    MaxVDSLUploadSpeed: string
    VDSL: {
      MaxVDSLSpeed: string
      MaxVDSLDownloadSpeed: string
      MaxVDSLUploadSpeed: string
      speeds: {
        MaxVDSLDownloadSpeed: string
        MaxVDSLUploadSpeed: string
      }
    }
    FIBER: {
      MaxFIBERSpeed: string
      MaxFIBERDownloadSpeed: string
      MaxFIBERUploadSpeed: string
    }
  }
}

export interface ZipcodeCheckResponse {
  cityId: number
  cityName: string
}

export interface StreetResponse {
  streetId: number
  streetName: string
}

export interface CityListResponse {
  cities: ZipcodeCheckResponse[]
}

export interface StreetListResponse {
  streets: StreetResponse[]
}

export const isAddressResponse = (response: any): response is AddressResponse => {
  return (
    response !== null &&
    typeof response === 'object' &&
    response.STATUS === 'OK' && // Validates the API status
    'prequal' in response &&
    response.prequal !== null &&
    typeof response.prequal === 'object' &&
    'City' in response.prequal
  )
}

export const isCityListResponse = (data: any): data is CityListResponse => {
  if (!Array.isArray(data)) {
    return false
  }
  if (data.length === 0) {
    return true
  }
  return 'cityId' in data[0] && 'cityName' in data[0]
}

export const isStreetListResponse = (data: any): data is StreetListResponse => {
  if (!Array.isArray(data)) {
    return false
  }
  if (data.length === 0) {
    return true
  }
  return 'streetId' in data[0] && 'streetName' in data[0]
}

export type { AddressResponse }
